import { GetFederatedTeamResponse } from '@cbinsights/authservice/authservice';
import { UseQueryResult, useQuery } from 'react-query';
import { GetFederatedTeam } from '.';
import { getFederatedTeam } from '../api/GetFederatedTeam';

type Params = Parameters<typeof getFederatedTeam>[0];
type Return = GetFederatedTeamResponse;

export const useGetFederatedTeam = ({
  enabled = false,
  params,
}: {
  enabled: boolean;
  params: Params;
}): UseQueryResult<Return, Error> =>
  useQuery<Return, Error, Return, [GetFederatedTeam, Params]>(
    ['GetFederatedTeam', params],
    () => getFederatedTeam(params),
    {
      enabled,
      notifyOnChangeProps: ['data', 'isFetching'],
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    }
  );
